import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drop-shadow-sm bg-white rounded-sm p-2" }
const _hoisted_2 = { class: "w-full overflow-hidden rounded-full bg-gray-300 passmeter-h" }
const _hoisted_3 = { class: "text-xs flex flex-row px-1 mt-1" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["passmeter-h", [ _ctx.color ]]),
        style: _normalizeStyle({ width: _ctx.getPercentage() })
      }, null, 6)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "flex-grow text-gray-500",
        textContent: _toDisplayString(_ctx.message)
      }, null, 8, _hoisted_4),
      _createElementVNode("div", {
        class: "text-gray-500",
        textContent: _toDisplayString(_ctx.getPercentage())
      }, null, 8, _hoisted_5)
    ])
  ]))
}